export default "__VITE_ASSET__4cb996bf__"